import React, { Component } from "react";  
//import Gallery from 'react-grid-gallery';

class Comp8 extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      branches: ''
    };  
  }  

   componentDidMount() {

      let info = this.props.paraminfo;

      this.setState({branches:info});

   }


  render() {  

    const { branches } = this.state;
    
    return <div id="ourbranch_section"><h3>Our Branches</h3>
                <div>No Branches</div>    
          </div>
  }  
}  
   
export default Comp8;